import React from 'react';
import { EventBody } from '../../libs/gds-api-client';
import { EventType } from './EventItem';
import { AutoFocusableFields } from './helper';

export type TypesOfEvents = 'Ceremony' | 'Reception' | 'WeddingEvent' | 'WeddingDay';

export type Event = EventType & { requireRsvp?: boolean };

interface EventProps {
  type: TypesOfEvents;
  event: Event | null;
  autoFillEventProperties?: EventBody;
  autoFocusField?: AutoFocusableFields | undefined;
}

export interface State {
  open: boolean;
  eventProps: EventProps;
}

export type Actions = { type: 'OPEN'; payload: EventProps } | { type: 'CLOSE' };

export const defaultEventProps = {
  type: 'WeddingEvent' as TypesOfEvents,
  event: null,
};

export const reducer = (state: State, action: Actions): State => {
  switch (action.type) {
    case 'OPEN':
      return { ...state, open: true, eventProps: action.payload };
    case 'CLOSE':
      return { ...state, open: false, eventProps: defaultEventProps };
    default:
      throw new Error('Case not defined');
  }
};

export const useEventModalReducer = () => {
  const [{ open, eventProps }, dispatch] = React.useReducer<(state: State, action: Actions) => State>(reducer, {
    open: false,
    eventProps: defaultEventProps,
  });

  const dispatchOpen = (payload: EventProps) => {
    dispatch({
      type: 'OPEN',
      payload,
    });
  };

  const dispatchClose = () => dispatch({ type: 'CLOSE' });
  return { open, eventProps, dispatchOpen, dispatchClose };
};
